import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import BigLabel from '../../shared/BigLabel';
import BlueBox from '../../shared/BlueBox';
import FFPaper from '../../shared/FFPaper';
import TinyLabel from '../../shared/TinyLabel';
import MediumLabel from '../../shared/MediumLabel';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import { NumberValue } from '../../../model/enrollment';
import { useTranslation } from 'react-i18next';

export interface TotalPeopleEnrolledProps {
    data?: NumberValue;
}

export default function TotalPeopleEnrolledCard( { data } : TotalPeopleEnrolledProps) {
    const { t } = useTranslation();

    return (

        <Grid item={true} xs={12}>
            <FFPaper
                elevation={3}
                sx={{
                    pb: "20px",
                    pt: "20px"
                }}
            >
                <Stack direction="row" sx={{ alignItems: 'center', width: '95%' }}>
                    <BlueBox sx={{
                        borderRadius: 2
                    }}>
                        <PeopleOutlineIcon fontSize="large" sx={{ backgroundColor: 'text.secondary', color: 'white', textAlign: 'center' }} />
                    </BlueBox>

                    <Stack sx={{ width: '100%', height: '100%', pb: 0, pt: 0 }}>

                        <Stack direction="row" sx={{
                            alignItems: 'center',
                        }}>

                            <BigLabel
                                sx={{
                                    textAlign: 'left',
                                    flex: '1 0 35%',

                                }}>{data?.value.toLocaleString()}</BigLabel>

                            <Stack sx={{
                                flex: '1 0 65%'
                            }}>
                                <TinyLabel>Updated 1 min ago</TinyLabel>

                                <MediumLabel>
                                    {t('enroll_total_people')}
                                </MediumLabel>

                            </Stack>
                        </Stack>

                    </Stack>

                </Stack>

            </FFPaper>
        </Grid>

    )

}
